export const sliders = () => (
  <path
    d="M4 21v-6m0 0a2 2 0 100-4 2 2 0 000 4zm0-7V3m8 18v-7m0-7V3m0 4a2 2 0 100 4 2 2 0 000-4zm8 14v-3m0 0a2 2 0 100-4 2 2 0 000 4zm0-7V3"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
